import React, { useEffect } from 'react';
import { cn } from '@/utils/cn';

function ModalWrapper({ children, isOpen, onOpenModal, className = '' }) {
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        onOpenModal(true);
      }, 100);
    } else {
      onOpenModal(false);
    }
  }, [isOpen]);

  return (
    <div
      className={cn(
        'modal-wrapper hidden w-full h-full bg-black/30 justify-center opacity-0 -z-10 transition-all duration-300 fixed inset-0 lg:pt-0 pt-[82px]',
        {
          '!opacity-100 flex !z-[501]': isOpen,
        },
        className,
      )}
    >
      {children}
    </div>
  );
}

export default ModalWrapper;
